import { EditorState } from 'draft-js'
import { TaskState } from '@src/editor-helpers'

export default (title: string, editorState: EditorState) => {
  const taskState = TaskState.fromEditorState(editorState)
  const currentContent = editorState.getCurrentContent()

  let report = {
    title: title + '\n',
    do: 'Делаем:\n',
    dontdo: 'Не делаем:\n',
    timeout: 'Таймаут:\n'
  }

  taskState.forEach(task => {
    if (task.decisionValue == null) return
    const decision = task.decisionValue

    task.solutionKeys.forEach(solutionKey => {
      const block = currentContent.getBlockForKey(solutionKey)
      report[decision] += block.getText() + '\n'
    })
    report[decision] += '\n'
  })

  const text = [report.title, report.do, report.dontdo, report.timeout].join('\n')
  return text
}



// WEBPACK FOOTER //
// ./src/editor-helpers/EditorStateOps/getTextFromState.ts